import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import PageHeader from "@/components/PageHeader";
import Districts from "@/pages/admin/Districts";
import Campuses from "@/pages/admin/Campuses";
import Teams from "@/pages/admin/Teams";

const VALID = ["districts", "campuses", "teams"];

export default function Organization() {
  const [searchParams] = useSearchParams();
  const initial = searchParams.get("tab");
  const [tab, setTab] = useState(VALID.includes(initial) ? initial : "districts");
  return (
    <div>
      <PageHeader title="Organization" subtitle="Manage your districts, campuses and teams in one place" />
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="mb-4" data-testid="organization-tabs">
          <TabsTrigger value="districts" data-testid="org-tab-districts">Districts</TabsTrigger>
          <TabsTrigger value="campuses" data-testid="org-tab-campuses">Campuses</TabsTrigger>
          <TabsTrigger value="teams" data-testid="org-tab-teams">Teams</TabsTrigger>
        </TabsList>
        <TabsContent value="districts" data-testid="org-panel-districts"><Districts embedded /></TabsContent>
        <TabsContent value="campuses" data-testid="org-panel-campuses"><Campuses embedded /></TabsContent>
        <TabsContent value="teams" data-testid="org-panel-teams"><Teams embedded /></TabsContent>
      </Tabs>
    </div>
  );
}
